import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const PortfolioPageObjClass = Scrivito.provideObjClass("PortfolioPage", {
  attributes: {
    ...defaultPageAttributes,
    breadcrumbWidget: ["widgetlist", { only: "BreadcrumbWidget" }],
    childOrder: "referencelist"
  },
  extractTextAttributes: ["body"],

  onlyChildren: ["ProductCategory"]
})
export type PortfolioPageObj = InstanceType<typeof PortfolioPageObjClass>
